import { render, staticRenderFns } from "./MoleculeContentNodeBlockIframeVideo.vue?vue&type=template&id=abe6a6c6&"
import script from "./MoleculeContentNodeBlockIframeVideo.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentNodeBlockIframeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports